import React from 'react'
import ModalContent from './ModalContent';
import { useStateContext } from '../context/StateContext';
import { urlFor } from '../lib/client';

const HorizontalSwipeSanity = ({images, offlineImages}) => {
    const{modalOpen, setModalOpen, setModalContent} = useStateContext();

    const modalContent = (item, index) =>    
    <ModalContent 
        setOpenModal={setModalOpen}
        setModalContent={setModalContent}
        title={"Picture Modal"}
        body={`Picture ${index}`}
        continueTo={()=>{
            //console.log("continue from parent")
        }}
        fullImage={item}
    />

    
  return (
<div className='horizontal-swipe-wrapper'>
        {!Array.isArray(images) ? [] : images?.map?.((item, index) => { 
            const key = index
            //console.log("knwkjdnewjkdnewjkd", item)
            // Only process valid image references
            const url = item?.asset?._ref ? urlFor(item).width(1020).height(1020)?.url() : undefined
            const onPicClick = () => {
                setModalContent(modalContent(item, index))
                setModalOpen(!modalOpen);
                //console.log("modal clicked", item)
            }
            return(
            <div key={key} onClick={()=>onPicClick()} className='horizontal-swipe-box'>
                {url && <img 
                    src={url}
                    style={{width:"120px", height:"120px"}}
                    className="product-image"
                />}
            </div>
        )})}

        {!Array.isArray(offlineImages) ? [] : offlineImages?.map?.((item, index) => { 
            const key = index
            //const url = urlFor(item && item).width(1020).height(1020)?.url()
            const base64 = item?.src
            const onPicClick = () => {
                //setModalContent(modalContent(item, index))
                //setModalOpen(!modalOpen);
                //console.log("modal clicked")
            }
            return(
            <div key={key} onClick={()=>onPicClick()} className='horizontal-swipe-box'>
                {base64 && <img 
                    src={base64}
                    //width={1020}
                    //height={1020}
                    style={{width:"120px", height:"120px"}}
                    className="product-image"
                />}
            </div>
        )})}
        
    </div>
  )
}

export default HorizontalSwipeSanity
